var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-container",
                { attrs: { "grid-list-md": "" } },
                [
                  _c(
                    "div",
                    { attrs: { align: "left" } },
                    [
                      _c("v-flex", { attrs: { md12: "" } }, [
                        _c("h2", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.creacion
                                  ? "Crear Ejecutivo"
                                  : _vm.edicion
                                  ? "Editar Ejecutivo"
                                  : ""
                              ) +
                              "\n            "
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c("br"),
                  _c(
                    "div",
                    { attrs: { id: "divCont" } },
                    [
                      _c(
                        "v-flex",
                        { staticClass: "fle" },
                        [
                          _c("v-combobox", {
                            attrs: {
                              label: "Correo",
                              items: _vm.optionsCorreos,
                              "item-text": "email",
                              "item-value": "email",
                              dense: "",
                              required: ""
                            },
                            on: { change: _vm.emitirParaGuardar },
                            model: {
                              value: _vm.correo,
                              callback: function($$v) {
                                _vm.correo = $$v
                              },
                              expression: "correo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { staticClass: "fle" },
                        [
                          _c("v-combobox", {
                            attrs: {
                              label: "Estado",
                              items: [
                                { llave: "🟢 Activo", valor: "t" },
                                { llave: "🔴 Inactivo", valor: "f" }
                              ],
                              "item-text": "llave",
                              "item-value": "valor",
                              dense: "",
                              required: ""
                            },
                            on: { change: _vm.emitirParaGuardar },
                            model: {
                              value: _vm.estado,
                              callback: function($$v) {
                                _vm.estado = $$v
                              },
                              expression: "estado"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }